import { useQuery } from "@tanstack/react-query";
import { fetchSuggestedProfile } from "PFCore/services/profile";
import { CurrentProfile, Id } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { profileKeys } from "./query_keys";

export const useSuggestedProfile = (profileId: Id, options: QueryOptions<CurrentProfile> = {}) =>
  useQuery<CurrentProfile>({
    queryKey: profileKeys.suggested(profileId),
    queryFn: () => fetchSuggestedProfile(profileId!),
    enabled: !!profileId,
    ...options
  });
